/**
 * Jertscript2 Keywords Map
 * Maps French keywords to their corresponding token types
 */

import { TokenType } from './tokens';

/**
 * Map of all French keywords to their token types
 * Keywords are case-sensitive and must be lowercase
 */
export const KEYWORDS: Map<string, TokenType> = new Map([
  // Variable declarations
  ['croissant', TokenType.CROISSANT],     // const
  ['baguette', TokenType.BAGUETTE],       // let

  // Boolean and null values
  ['oui', TokenType.OUI],                 // true
  ['non', TokenType.NON],                 // false
  ['rien', TokenType.RIEN],               // null

  // Control flow
  ['franchement', TokenType.FRANCHEMENT], // if
  ['sinon', TokenType.SINON],             // else
  ['pendant', TokenType.PENDANT],         // while
  ['pour', TokenType.POUR],               // for

  // Functions
  ['fonction', TokenType.FONCTION],       // function
  ['retourner', TokenType.RETOURNER],     // return

  // Async/await
  ['asynchrone', TokenType.ASYNCHRONE],   // async
  ['attendre', TokenType.ATTENDRE],       // await

  // Classes
  ['classe', TokenType.CLASSE],           // class
  ['nouveau', TokenType.NOUVEAU],         // new
  ['ceci', TokenType.CECI],               // this
  ['constructeur', TokenType.CONSTRUCTEUR], // constructor

  // Error handling
  ['malheureusement', TokenType.MALHEUREUSEMENT], // try
  ['merde', TokenType.MERDE],             // catch
  ['quandmeme', TokenType.QUANDMEME],     // finally
  ['lancer', TokenType.LANCER],           // throw

  // Modules
  ['importer', TokenType.IMPORTER],       // import
  ['exporter', TokenType.EXPORTER],       // export
  ['de', TokenType.DE],                   // from

  // Logical operators
  ['et', TokenType.ET],                   // &&
  ['ou', TokenType.OU],                   // ||
  ['pas', TokenType.PAS],                 // !
  ['est', TokenType.EST],                 // ===
  ['nest_pas', TokenType.NEST_PAS],       // !==

  // Loop control
  ['casser', TokenType.CASSER],           // break
  ['continuer', TokenType.CONTINUER],     // continue

  // Type keywords
  ['nombre', TokenType.NOMBRE],           // number
  ['texte', TokenType.TEXTE],             // string
  ['booleen', TokenType.BOOLEEN],         // boolean
  ['quelconque', TokenType.QUELCONQUE],   // any
  ['inconnu', TokenType.INCONNU],         // unknown
  ['jamais', TokenType.JAMAIS],           // never
  ['vide', TokenType.VIDE],               // void
  ['tableau', TokenType.TABLEAU],         // Array
  ['promesse', TokenType.PROMESSE],       // Promise

  // Type system
  ['interface', TokenType.INTERFACE],     // interface
  ['type', TokenType.TYPE],               // type
  ['enumeration', TokenType.ENUMERATION], // enum
  ['etend', TokenType.ETEND],             // extends
  ['implemente', TokenType.IMPLEMENTE],   // implements
  ['comme', TokenType.COMME],             // as

  // Access modifiers
  ['prive', TokenType.PRIVE],             // private
  ['publique', TokenType.PUBLIQUE],       // public
  ['protege', TokenType.PROTEGE],         // protected
  ['lecture_seule', TokenType.LECTURE_SEULE], // readonly
]);

/**
 * Check if a given identifier is a reserved keyword
 * @param identifier The identifier to check
 * @returns true if the identifier is a reserved keyword
 */
export function isKeyword(identifier: string): boolean {
  return KEYWORDS.has(identifier.toLowerCase());
}

/**
 * Get the token type for a keyword, or IDENTIFIER if not a keyword
 * @param identifier The identifier to look up
 * @returns The token type for the keyword, or TokenType.IDENTIFIER
 */
export function getKeywordType(identifier: string): TokenType {
  return KEYWORDS.get(identifier.toLowerCase()) ?? TokenType.IDENTIFIER;
}
